const getThemeColor = () => {
  const theme = typeof window !== "undefined" && window.__theme

  if (theme === "light") return "#fbfbff"
  if (theme === "dark") return "rgba(45, 46, 50, 0.97)"
}

export default getThemeColor
